import React, { Component } from "react";
import { Link } from "react-router-dom";
import IOnProcessPOShipmentDTO from "../../../models/DTO/IOnProcessPOShipmentDTO";
import IProcessPOShipmentDTO from "../../../models/DTO/IProcessPOShipmentDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOwTableCols from "../../../models/IOwTableCols";
import IPO_Shipment from "../../../models/IPO_Shipment";
import IPurchase_Order from "../../../models/IPurchase_Order";
import ISupplierModel from "../../../models/ISupplierModel";
import IUser from "../../../models/IUser";
import IUserUI from "../../../models/IUserUI";
import PurchaseOrderStateEnum from "../../../models/PurchaseOrderStateEnum";
import UserService from "../../../services/UserService";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTable from "../../shared/OwTable/OwTable";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    purchaseOrder: IPurchase_Order;
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    history: any;
    isReadOnly: boolean;
};

type State = {
    columns: IOwTableCols[];
};

class PurchaseOrderShipmentsDetailView extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            columns: [
                {
                    isActionsCol: true,
                    title: "",
                    valueProp: "",
                    renderFn: this.renderActionsFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "shipment",
                    valueProp: "",
                    renderFn: this.renderShipmentNameFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "status",
                    valueProp: "",
                    renderFn: this.renderShipmentStatusFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "processed_by",
                    valueProp: "",
                    renderFn: this.renderProcessedByFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "created_at",
                    valueProp: "",
                    renderFn: this.renderCreatedAtFn,
                    renderFnEmitsRow: true,
                },
            ],
        };
    }

    componentDidMount() {
        this.props.socket.on(EndpointsEnum.PurchaseOrderOnProcessPOShipment, this.onProcessPOShipment);
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.PurchaseOrderOnProcessPOShipment, this.onProcessPOShipment);
    }

    renderActionsFn = () => {};

    renderShipmentNameFn = (row: IPO_Shipment, index: number) => {
        return (
            <div>
                <Link to={`/purchase_orders/process_shipment/${row.guid}`} className={"pointer"}>
                    <OwLabel title={"shipment"} postText={"#:"} className={"me-2 pointer"} />
                    {index + 1}
                </Link>
            </div>
        );
    };

    renderShipmentStatusFn = (row: IPO_Shipment, index: number) => {
        return <div>{row.is_processed ? <OwLabel title={"processed"} /> : <OwLabel title={"open"} />}</div>;
    };

    renderCreatedAtFn = (row: IPO_Shipment) => {
        return UserService.parseDate(row.created_at);
    };

    renderProcessedByFn = (row: IPO_Shipment) => {
        return row.User?.name;
    };

    receiveShipment = () => {
        const payload: IProcessPOShipmentDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            purchaseOrderGuids: [this.props.purchaseOrder.guid],
            poShipment: {
                vendor_source_id: this.props.purchaseOrder.vendor_source_id,
            },
        };

        this.props.socket.emit(EndpointsEnum.PurchaseOrderProcessPOShipment, payload);
    };

    onProcessPOShipment = (data: IOnProcessPOShipmentDTO) => {
        this.props.history(`/purchase_orders/process_shipment/${data.poShipment.guid}`);
    };

    render() {
        return (
            <div className="PurchaseOrderShipmentsDetailView">
                <div>
                    {this.props.purchaseOrder.po_state_id !== PurchaseOrderStateEnum.RECEIVED && !this.props.isReadOnly ? (
                        <OwButton title={"receive_shipment"} fn={this.receiveShipment} className={"btn-warning mb-2"} />
                    ) : null}
                </div>
                <div>
                    <OwTable
                        columns={this.state.columns}
                        dataSet={this.props.purchaseOrder.PO_Shipments || []}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={false}
                        initialData={false}
                    />
                </div>
            </div>
        );
    }
}

export default PurchaseOrderShipmentsDetailView;
